import { render, staticRenderFns } from "./BatteryPanel.vue?vue&type=template&id=81a90a50&"
import script from "./BatteryPanel.vue?vue&type=script&lang=js&"
export * from "./BatteryPanel.vue?vue&type=script&lang=js&"
import style0 from "./BatteryPanel.vue?vue&type=style&index=0&id=81a90a50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports